<ejs-toast #element [position]="{ X: 'Right', Y: 'Bottom' }" [showCloseButton]='true'  [showProgressBar]='true' 
 [icon]="'e-meeting'" [width]="'500px'" [timeOut]='6000' >
  <ng-template #title>
    <div>Matt sent you a friend request</div>
</ng-template>
<ng-template #content>
    <div>Hey, wanna dress up as wizards and ride our hoverboards?</div>
</ng-template>
</ejs-toast>